import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle
import CostOfOwnership from 'components/Comparison/LineItems/CostOfOwnership';
// eslint-disable-next-line import/no-cycle
import Safety from 'components/Comparison/LineItems/Safety';
// eslint-disable-next-line import/no-cycle
import Interior from 'components/Comparison/LineItems/Interior';
// eslint-disable-next-line import/no-cycle
import UnderTheHood from 'components/Comparison/LineItems/UnderTheHood';
// styles
import { screen, colors } from 'components/styles/variables';
import { columnStyles } from 'components/styles/comparisons';
// eslint-disable-next-line import/no-cycle
import PricingAndAvailability from './PricingAndAvailability';

function VehicleHeader({ vehicle1, vehicle2 }) {
  const { t } = useTranslation();

  function formattedVehicleName({ year, make, model }) {
    return t('comparison.ymm', { year, make, model });
  }

  return (
    <div className="vehicle-header columns">
      <div className="column">
        <h4 className="title">{formattedVehicleName(vehicle1)}</h4>
      </div>
      <div className="column">
        <h4 className="title">{formattedVehicleName(vehicle2)}</h4>
      </div>
      <style jsx>{columnStyles}</style>
      <style jsx>{`
        .title {
          font-size: 23px;
          line-height: 23px;
          margin: 0;
        }

        @media (min-width: ${screen.smMin}) {
          .title {
            font-size: 26px;
            line-height: 26px;
          }
        }

        .columns {
          margin-bottom: 15px;
        }

        @media (min-width: ${screen.smMin}) {
          .columns {
            margin-bottom: 5px;
          }
        }
      `}</style>
    </div>
  );
}
VehicleHeader.propTypes = {
  vehicle1: PropTypes.object,
  vehicle2: PropTypes.object,
};

export function LineItemContainer({ title, comparison, children }) {
  return (
    <div className="line-item-container">
      <h3 className="title">{title}</h3>
      <VehicleHeader
        vehicle1={comparison.vehicle1}
        vehicle2={comparison.vehicle2}
      />
      <div>{children}</div>
      <style jsx>{`
        .line-item-container {
          margin-top: 60px;
        }

        .title {
          font-size: 36px;
          margin: 0 0 15px 0;
        }
      `}</style>
    </div>
  );
}
LineItemContainer.propTypes = {
  title: PropTypes.string,
  comparison: PropTypes.object,
  children: PropTypes.node,
};

const columnStateClass = (currentVehicle, winningVehicle) =>
  currentVehicle === winningVehicle ? 'winner' : '';

export function LineItemValue({
  comparison,
  getValue,
  getSubText,
  determineWinner,
}) {
  const winningVehicle = determineWinner(comparison);

  return (
    <div className="line-item-values columns">
      <div
        className={`column ${columnStateClass(
          comparison.vehicle1,
          winningVehicle
        )}`}
      >
        <div className="value">{getValue(comparison.vehicle1)}</div>
        <div className="subtext">{getSubText(comparison.vehicle1)}</div>
      </div>
      <div
        className={`column ${columnStateClass(
          comparison.vehicle2,
          winningVehicle
        )}`}
      >
        <div className="value">{getValue(comparison.vehicle2)}</div>
        <div className="subtext">{getSubText(comparison.vehicle2)}</div>
      </div>
      <style jsx>{columnStyles}</style>
      <style jsx>{`
        .columns {
          margin-top: 10px;
        }

        .column {
          padding: 8px 5px;
        }

        .value {
          font-size: 16px;
          line-height: 16px;
          font-weight: 900;
        }

        .subtext {
          font-size: 14px;
        }

        .winner {
          border-top: 2px solid ${colors.ALG1};
          background-color: ${colors.LEGACYGREEN};
        }
      `}</style>
    </div>
  );
}

LineItemValue.propTypes = {
  comparison: PropTypes.object,
  getValue: PropTypes.func,
  getSubText: PropTypes.func,
  determineWinner: PropTypes.func,
};

export function LineItem({ title, children }) {
  return (
    <div className="line-item">
      <h5 className="title">{title}</h5>
      <hr className="divider" />
      {children}
      <style jsx>{`
        .line-item {
          margin-top: 20px;
        }

        .title {
          font-size: 20px;
          line-height: 20px;
          margin: 0;
        }

        @media (min-width: ${screen.smMin}) {
          .title {
            margin-top: 15px;
            font-size: 16px;
            line-height: 16px;
          }
        }

        .divider {
          color: ${colors.G4};
          margin: 5px 0 5px 0;
          border-width: 2px;
        }
      `}</style>
    </div>
  );
}
LineItem.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export default function LineItems({ comparison, listings }) {
  return (
    <section>
      {listings ? (
        <PricingAndAvailability comparison={comparison} listings={listings} />
      ) : null}
      <CostOfOwnership comparison={comparison} />
      <Safety comparison={comparison} />
      <Interior comparison={comparison} />
      <UnderTheHood comparison={comparison} />
    </section>
  );
}

LineItems.propTypes = {
  comparison: PropTypes.object,
  listings: PropTypes.object,
};
